<div *ngIf="tags" class="d-flex flex-row">
  <ul class="tag-list d-flex flex-row flex-wrap align-items-center m-0">
    <p class="subhead color-500 m-0 me-2 mb-1">Tags:</p>
    <li
      *ngFor="let tag of tags; trackBy: trackByTag; let i = index"
      class="pe-2 mb-1"
      data-test="tag"
    >
      <flo-tag
        *ngIf="i < 15"
        [tag]="tag"
        [collectionTabUriPart]="collectionTabUriPart"
      ></flo-tag>
    </li>
  </ul>
</div>
